import { render, staticRenderFns } from "./NewsCategoryAdd.vue?vue&type=template&id=30ddda38&"
import script from "./NewsCategoryAdd.vue?vue&type=script&lang=js&"
export * from "./NewsCategoryAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports